import qiraTheme from './qira-theme';
import { definePreset } from '@primeuix/themes';

export const QiraPreset = definePreset(qiraTheme, {
  name: 'qira',
});
